import { COLORS } from '@btime/constants'
import React from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const BottomSquare = ({ selected }) => (
  <div
    style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0
    }}
  >
    <div
      style={{
        margin: 'auto',
        width: '25px',
        height: '25px',
        borderWidth: '1px 1px 0px 1px',
        borderColor: COLORS.dark4,
        borderStyle: 'solid'
      }}
    >
      {!!selected && (
        <Text bold align="center">
          X
        </Text>
      )}
    </div>
  </div>
)

const StaticTablesSection = ({ certify }) => {
  return (
    <View id="B">
      <Text bold size="small" align="center">
        ANEXO B – TABELA 1 (GHE1 E 2) – CONFORME ITEM 10.3.2 –AET
      </Text>

      <Separator weight={4} />

      <Text bold size="small" align="center">
        TABELA 1 – GHE 1 / GHE 2
      </Text>

      <Separator weight={4} />

      <Table width="100%">
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Questões a ponderar (fatores de risco possíveis)
          </TableHeadText>
          <TableHeadText colSpan={3} align="center">
            Avaliação de risco (ZONA)
          </TableHeadText>
        </TableRow>
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Passo 1 - Movimentos repetitivos/duração - O trabalho envolve
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightGreen} align="center">
            VERDE, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.yellow} align="center">
            AMARELO, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightRed} align="center">
            VERMELHO, se...
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText align="center">Sim</TableHeadText>
          <TableHeadText align="center">Não</TableHeadText>
          <TableHeadText align="center">Tipo de Movimento Repetitivo</TableHeadText>

          <TableColText align="center" rowSpan={20}>
            Não evidenciado movimentos repetitivos e nenhum outro fator de risco, por não mais de um total de 3 h, em um
            dia de trabalho "NORMAL". E Não mais de 1h sem intervalo
            <BottomSquare selected />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            As condições descritas na zona vermelha e verde não são verdadeiras.
            <BottomSquare />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            Movimentos repetitivos se quaisquer outros fatores de risco por mais de 4 h, em um dia de trabalho "NORMAL".
            <BottomSquare />
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Um ciclo de trabalho ou uma sequência de movimentos que seja repetida mais que duas vezes por minuto e por
            mais de 50% da duração da tarefa?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Repetir movimentos quase idênticos dos dedos, mãos ou braços a cada segundo?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Uso intenso do(s) dedo(s), mão(s) ou punho(s)?</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Movimentos repetitivos do ombro/braço (movimentos regulares do braço com algumas pausas ou quase contínuos)?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center" colSpan={3}>
            Se a resposta a todas as perguntas for "NÃO", a avaliação é VERDE e não é mais necessária qualquer
            avaliação.
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center" colSpan={3}>
            Se a resposta a uma ou mais perguntas for "SIM", o trabalho é categorizado como repetitivo. Usar colunas à
            direita para avaliar duração aceitável, se nenhum outro fator de risco significativo estiver presente,
            continuar para avaliação de outros fatores de risco combinados pelos passos 2, 3 e 4.
          </TableColText>
        </TableRow>
      </Table>

      <Separator weight={12} />

      <Text bold size="small" align="center">
        TABELA 1 – GHE 1 / GHE 2
      </Text>

      <Separator weight={8} />

      <Table width="100%">
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Questões a ponderar (fatores de risco possíveis)
          </TableHeadText>
          <TableHeadText colSpan={3} align="center">
            Avaliação de risco (ZONA)
          </TableHeadText>
        </TableRow>
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Passo 2- Movimentos repetitivos/duração - O trabalho envolve repetitividade ou frequência
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightGreen} align="center">
            VERDE, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.yellow} align="center">
            AMARELO, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightRed} align="center">
            VERMELHO, se...
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText align="center">Sim</TableHeadText>
          <TableHeadText align="center">Não</TableHeadText>
          <TableHeadText align="center">(ver Tabela item 14)</TableHeadText>

          <TableColText align="center" rowSpan={20}>
            Não evidenciado repetitividade, pequenos desvios das posições neutras dos dedos, punho, cotovelos, ombros ou
            pescoço por não mais de 3 h por dia de trabalho / OU Repetitividade, desvios moderados a maiores por não
            mais de 2 h por dia de trabalho / E (AMBOS) Não mais de 30 min consecutivos sem um intervalo ou variação de
            tarefa.
            <BottomSquare selected />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            As condições descritas nas zonas vermelhas e verde não forem verdadeiras
            <BottomSquare />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            Desvios moderados às maiores das posições neutras das articulações dos dedos, punhos, cotovelos, ombros ou
            pescoço por mais de 3 h por dia de trabalho E Menos se mais de 30 min sem intervalo. (Desvios moderados para
            maiores de articulações, significando >50% do ROM. Se houver desvios máximos perto de ROM, uma avaliação
            específica é necessária).
            <BottomSquare />
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Desviar o punho para cima ou para baixo ou para om lado?</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Virar ou torcer as mãos de tal maneira que as palmas estejam viradas para cima ou para baixo?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Movimentos de força, como segurar com os dedos enquanto o punho está desviado, mão bem aberta para segurar
            ou manipular itens?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Movimentos do braço para frente ou para os lados do corpo?</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Inclinação lateral ou movimentos giratórios das costas ou da cabeça?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center" colSpan={3}>
            Se a resposta a todas as perguntas for "NÃO", então não há nenhuma postura inadequada como um fator de risco
            combinado para os movimentos repetitivos. Continuar para o passo 3 para avaliação do fator força.
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center" colSpan={3}>
            Se a resposta para uma ou mais perguntas for "SIM", usar as colunas à direita para avaliar o risco e depois
            proceder ao passo 3.
          </TableColText>
        </TableRow>
      </Table>

      <Separator weight={12} />

      <Text bold size="small" align="center">
        TABELA 1 – GHE 1 / GHE 2
      </Text>

      <Separator weight={8} />

      <Table width="100%">
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Questões a ponderar (fatores de risco possíveis)
          </TableHeadText>
          <TableHeadText colSpan={3} align="center">
            Avaliação de risco (ZONA)
          </TableHeadText>
        </TableRow>
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Passo 3 - Força - O trabalho envolve repetitivo ou frequente...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightGreen} align="center">
            VERDE, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.yellow} align="center">
            AMARELO, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightRed} align="center">
            VERMELHO, se...
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText align="center">Sim</TableHeadText>
          <TableHeadText align="center">Não</TableHeadText>
          <TableHeadText align="center">(ver Tabela item 14)</TableHeadText>

          <TableColText align="center" rowSpan={20}>
            Não evidenciado esforço repetitivo (sem posturas inadequadas) por não mais de 2 h por dia normal de trabalho
            OU Não evidenciado esforço repetitivo combinado com posturas inadequadas por mais de 1 h por dia normal de
            trabalho E (ambos) Não mais de 30 min consecutivos sem um intervalo ou variação de tarefa
            <BottomSquare selected />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            As condições descritas nas zonas vermelhas e verde não forem verdadeiras
            <BottomSquare />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            Esforço repetitivo sem posturas inadequadas por mais de 3h por dia normal de trabalho OU Esforço repetitivo
            combinado com posturas inadequadas por mais de 2 h por dia normal de trabalho (duração mais curta se mais de
            30 min consecutivos sem um intervalo ou variação de tarefa).
            <BottomSquare />
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText colSpan={3}>
            a) Levantar ou segurar ferramentas, materiais ou objetos que pesem mais que:
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">0,2 Kg por dedo (levantados ou pinçados)</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">2 Kg por mão?</TableColText>
        </TableRow>

        <TableRow>
          <TableColText colSpan={3}>b) Segurar, girar, empurrar ou puxar ferramentas, materiais.</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            por trabalho de braço/mão com uma força que exceda 10% dos valores de referência, Fb, como dado em EM
            1005-3:2002(53), passo 1(por exemplo, 25N ou 2,5kgf para força de pressão)?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText colSpan={3}>c) Uso de atuadores de controle</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            com uma força/torque que exceda o recomendado pela ISO9355-3(67), (por exemplo, 25N ou 2,5kgf para força de
            preensão de mão)?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText colSpan={3}>d) Preensão de pinça, isto é, segurar objetos entre o dedão e um dedo</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Com uma força de mais de 10N ou 1kgf?</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center" colSpan={3}>
            Se a resposta a todas essas perguntas for "NÃO", então não há qualquer esforço como um fatorcombinado de
            risco para os movimentos repetitivos. Continuar com o passo 4 para avaliar o fator de recuperação. Se a
            resposta de uma ou mais das perguntas for "SIM", avaliar o risco usando a coluna à direita, depois proceder
            o passo 4.
          </TableColText>
        </TableRow>
      </Table>

      <Separator weight={12} />

      <Text bold size="small" align="center">
        TABELA 1 – GHE 1 / GHE 2
      </Text>

      <Separator weight={8} />

      <Table width="100%">
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Questões a ponderar (fatores de risco possíveis)
          </TableHeadText>
          <TableHeadText colSpan={3} align="center">
            Avaliação de risco (ZONA)
          </TableHeadText>
        </TableRow>
        <TableRow>
          <TableHeadText colSpan={3} align="center">
            Passo 4 - Períodos de recuperação - O trabalho envolve...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightGreen} align="center">
            VERDE, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.yellow} align="center">
            AMARELO, se...
          </TableHeadText>
          <TableHeadText bgColor={COLORS.lightRed} align="center">
            VERMELHO, se...
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText align="center">Sim</TableHeadText>
          <TableHeadText align="center">Não</TableHeadText>
          <TableHeadText align="center">(ver Tabela item 14)</TableHeadText>

          <TableColText align="center" rowSpan={20}>
            Pelo menos 30 min para almoço e 10 min de intervalo de manhã e 10 min de intervalo à tarde E Não mais que 1
            h de trabalho sem intervalo ou variação de tarefa
            <BottomSquare selected />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            A condição descrita nas zonas vermelha e verde não forem verdadeiras
            <BottomSquare />
          </TableColText>

          <TableColText align="center" rowSpan={20}>
            A condição descrita nas zonas vermelha e verde não forem verdadeiras
            <BottomSquare />
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Falta de intervalos?</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Pouca variação de tarefas?</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Falta de períodos de recuperação</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center" colSpan={3}>
            Usar as colunas à direita para responder a essas perguntas e avaliar o risco de falta de períodos de
            recuperação. Depois proceder o passo 5 e avaliar fatores adicionas de risco
          </TableColText>
        </TableRow>
      </Table>

      <Separator weight={12} />

      <Text bold size="small" align="center">
        TABELA 1 – GHE 1 / GHE 2
      </Text>

      <Separator weight={8} />

      <Table width="100%">
        <TableRow>
          <TableHeadText colSpan={10} align="center">
            Questões a considerar (fatores de risco possíveis)
          </TableHeadText>
        </TableRow>
        <TableRow>
          <TableHeadText colSpan={10} align="center">
            Passo 5 - Fatores complementares de risco (Ver Tabela do item 14)
          </TableHeadText>
        </TableRow>
        <TableRow>
          <TableHeadText colSpan={3} align="center" width="50%">
            Físico
          </TableHeadText>

          <TableHeadText colSpan={7} align="center" width="50%">
            Psicossocial
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText align="center" bold>
            Sim
          </TableColText>
          <TableColText align="center" bold>
            Não
          </TableColText>
          <TableColText align="center" bold>
            O trabalho envolve...
          </TableColText>

          <TableColText align="center" bold>
            Sim
          </TableColText>
          <TableColText align="center" bold>
            Não
          </TableColText>
          <TableColText align="center" bold colSpan={5}>
            O trabalho envolve...
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Uso de ferramentas vibratórias?</TableColText>

          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center" colSpan={5}>
            Pressão alta no trabalho/muito trabalho para terminar dentro do horário de trabalho?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Compressão localizada de estruturas anatômicas devido a ferramentas?
          </TableColText>

          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center" colSpan={5}>
            Falta de controle de planejamento e organização das tarefas do trabalho?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Exposição a calor ou frio?</TableColText>

          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center" colSpan={5}>
            Falta de apoio de colegas e gerentes?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Equipamento de proteção pessoal que restringe movimentos ou prejudica o desempenho?
          </TableColText>

          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center" colSpan={5}>
            Alta carga de trabalho mental, alta concentração ou atenção?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Risco de movimento súbito, inesperado/descontrolado (por exemplo, chão escorregadio, objetos caindo)?
          </TableColText>

          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center" colSpan={5}>
            Uma tarefa isolada em um processo de produção?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Aceleração/desaceleração súbita de movimentos?</TableColText>

          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center" colSpan={5}>
            Ritmo de trabalho controlado por uma máquina ou pessoas?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Força/carga estática? Por exemplo...</TableColText>

          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center" colSpan={5}>
            Taxas de trabalho predefinidas ou sistemas de bônus?
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Ombros/braços elevados (levantar os braços/objetos contra a gravidade)?
          </TableColText>

          <TableHeadText align="center" colSpan={7}>
            RESULTADOS
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText align="center" rowSpan={2}></TableColText>
          <TableColText align="center" rowSpan={2}>
            X
          </TableColText>
          <TableColText align="center" rowSpan={2}>
            Preensão contínua de ferramentas (como facas em um frigorífico, indústria de peixes)?
          </TableColText>

          <TableColText align="center" bold rowSpan={2} colSpan={2}>
            ZONA
          </TableColText>

          <TableColText align="center" bold colSpan={5}>
            Passos
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center" bold>
            1
          </TableColText>

          <TableColText align="center" bold>
            2
          </TableColText>

          <TableColText align="center" bold>
            3
          </TableColText>

          <TableColText align="center" bold>
            4
          </TableColText>

          <TableColText align="center" bold>
            5
          </TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">
            Posturas presas ou fixas (mau projeto de ferramentas ou locais de trabalho, falta de espaço)?
          </TableColText>

          <TableColText align="center" bgColor={COLORS.lightGreen} colSpan={2}>
            VERDE
          </TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">X</TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Martelar, choques ou força com crescimento rápido?</TableColText>

          <TableColText align="center" bgColor={COLORS.yellow} colSpan={2}>
            AMARELO
          </TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
        </TableRow>

        <TableRow>
          <TableColText align="center"></TableColText>
          <TableColText align="center">X</TableColText>
          <TableColText align="center">Trabalho de alta precisão combinado com força?</TableColText>

          <TableColText align="center" bgColor={COLORS.lightRed} colSpan={2}>
            VERMELHO
          </TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
          <TableColText align="center"></TableColText>
        </TableRow>
      </Table>

      <Separator weight={8} />
    </View>
  )
}

export default StaticTablesSection
